import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import Header from "./components/header";
import Footer from "./components/footer";
import Home from "./pages/home";
import Player from "./pages/playerProfile";
import Team from "./pages/teamProfile";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/scss/app.scss";
import { Route, Switch, useLocation } from "react-router-dom";
import Login from "./pages/authentication/login";
import Signup from "./pages/authentication/signup";
import TermsAndCondition from "./pages/termsAndCondition";
import PrivacyAndPolicy from "./pages/privacyAndPolicy";
import players from "./pages/players";
import ScanIndex from "./oldRoutes/scan";
import GalleryIndex from "./oldRoutes/gallery";
import AdminDashboard from "./oldRoutes/admin/dashboard";
import Profile from "./pages/userProfile/Profile";
import { CirclesWithBar } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { IReduxStateData } from "./interfaces/redux";
import ReactPlayer from "react-player";
import axios from "axios";
import { getTodayDate } from "./common/dateFunction";
import { loaderDisplayHideAction } from "./actions";
import findMaxOrEqualDate from "./common/findMaxOrEqualDate";
import VideoWrapper from "./pages/videoWrapper";
import EncryptData from "./common/encryption";
import AboutUs from "./pages/aboutUs";
import DiffTeamPlayersList from "./pages/diffTeamPlayersList";
import Teams from "./pages/teams";
import { GoogleOauthContext } from "./common/context";
import ScrollToTop from "./common/scrollToTop";
import GetActiveDealAdvertisement from "./common/getActiveDealAdvertisement";
import { isMobileOnly } from "react-device-detect";
import { Button } from "react-bootstrap";
import { FaFastForward } from "react-icons/fa";
import decryptData from "./common/decryption";

const App: React.FC<{}> = () => {
  const globalState = useSelector((state: IReduxStateData) => state);
  const globalLoaderCheck = useSelector(
    (state: IReduxStateData) => state.isFullScreenLoaderDisplay
  );
  const globalActiveAdv = useSelector(
    (state: IReduxStateData) => state.activeDealAdvertisement
  );
  const [isUnderMaintenance, setIsUnderMaintenance] = useState({
    value: false,
    time: "",
  });
  const [isGoogleOauthEnable, setIsGoogleOauthEnable] = useState(false);
  const dispatch = useDispatch();
  const loaderDisplayHideRedux = useCallback(
    (data) => {
      dispatch(loaderDisplayHideAction(data));
    },
    // eslint-disable-next-line
    [dispatch]
  );
  const advertiseMaxTime = 30;
  const [advertisePlayingIndex, setAdvertisePlayingIndex] = useState(-1);
  const [advertisementDetail, setAdvertisementDetail] = useState<any[]>([]);
  const location = useLocation();
  const dealVideoDisplayed = localStorage.getItem("dealVideoDisplayed")
    ? decryptData(localStorage.getItem("dealVideoDisplayed") || "")
    : false;
  const isLoginWithParams = /^\/login\/[^/]+\/[^/]+$/.test(location.pathname);
  // http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4
  // https://youtu.be/NljGurzPM2g
  const fetchSiteSetting = () => {
    loaderDisplayHideRedux({ isFullScreenLoaderDisplay: true });
    axios
      .get(process.env.REACT_APP_API_URL + "/common/get-site-setting")
      .then(function (response) {
        if (response.data.success) {
          const res = response.data.success;
          const getDate = getTodayDate();
          if (res["intro_video"]) {
            localStorage.setItem(
              "intoVideoIdentifier",
              EncryptData(res["intro_video"])
            );
            localStorage.setItem("displayIntro", EncryptData("true"));
          } else {
            localStorage.removeItem("intoVideoIdentifier");
            localStorage.removeItem("displayIntro");
          }
          if (
            res["site_under_maintenance"] &&
            res["site_up_time"] &&
            findMaxOrEqualDate(res["site_up_time"], getDate) === 1
          ) {
            if (!isUnderMaintenance?.value) {
              setIsUnderMaintenance({
                value: true,
                time: res["site_up_time"],
              });
            }
          } else {
            if (isUnderMaintenance?.value) {
              setIsUnderMaintenance({
                value: false,
                time: "",
              });
            }
          }
          if (res.hasOwnProperty("is_enable_google_oauth")) {
            if (isGoogleOauthEnable !== res["is_enable_google_oauth"])
              setIsGoogleOauthEnable(
                res["is_enable_google_oauth"] ? true : false
              );
          }
          loaderDisplayHideRedux({
            isFullScreenLoaderDisplay: false,
          });
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        loaderDisplayHideRedux({ isFullScreenLoaderDisplay: false });
      });
  };
  useEffect(() => {
    if (globalActiveAdv && !isLoginWithParams) {
      const advertisementForPage: any = GetActiveDealAdvertisement(
        globalState,
        0,
        4
      );
      console.log("advertisementForPage >", advertisementForPage);
      const itemList: any[] = [];
      const advList =
        advertisementForPage && Array.isArray(advertisementForPage)
          ? advertisementForPage
          : [{ ...advertisementForPage }];
      advList?.forEach((item) => {
        if (item.type === 3) {
          itemList.push({
            position:
              item.position === 1
                ? "top-left"
                : item.position === 2
                ? "top-right"
                : item.position === 4
                ? "bottom-left"
                : "bottom-right",
            timeDuration: "",
            isDisplay: true,
            activeAdvert: item.source,
          });
        }
      });
      setAdvertisementDetail(itemList);
      if (itemList.length) {
        setAdvertisePlayingIndex(0);
      }
    }
  }, [globalActiveAdv]);
  useEffect(() => {
    if (advertisePlayingIndex !== -1) {
      const header = document.getElementsByTagName("header")[0];
      const topHeight = header?.clientHeight || 0;
      const offSetValue = isMobileOnly ? 5 : 20;
      const css = {
        "top-left": {
          top: topHeight + offSetValue,
          left: offSetValue,
        },
        "top-right": {
          top: topHeight + offSetValue,
          right: offSetValue,
        },
        "bottom-left": {
          left: offSetValue,
          bottom: offSetValue,
        },
        "bottom-right": {
          right: offSetValue,
          bottom: offSetValue,
        },
      };
      const ele: any = document.getElementById("video-wrapper");
      const eleOverlay: any = document.getElementById(
        "video-wrapper-overlay-adv"
      );
      if (ele && css[advertisementDetail[advertisePlayingIndex]["position"]]) {
        for (const propertyObj in css[
          advertisementDetail[advertisePlayingIndex]["position"]
        ]) {
          ele.style[propertyObj.toString()] =
            css[advertisementDetail[advertisePlayingIndex]["position"]][
              propertyObj.toString()
            ] + "px";
          if (eleOverlay) {
            eleOverlay.style[propertyObj.toString()] =
              css[advertisementDetail[advertisePlayingIndex]["position"]][
                propertyObj.toString()
              ] + "px";
          }
        }
      }
    }
  }, [advertisePlayingIndex]);

  useEffect(() => {
    if (!isLoginWithParams) fetchSiteSetting();
  }, []);

  const nextAdvertise = () => {
    console.log("kkk");
    if (advertisePlayingIndex !== advertisementDetail.length - 1) {
      setAdvertisePlayingIndex(advertisePlayingIndex + 1);
    } else {
      setAdvertisePlayingIndex(-1);
      localStorage.setItem("dealVideoDisplayed", EncryptData("true"));
    }
  };

  return (
    <GoogleOauthContext.Provider value={isGoogleOauthEnable}>
      <div
        id="loading-wrapper"
        key={globalLoaderCheck ? "true" : "false"}
        className={!globalLoaderCheck ? "loader-hide" : ""}
      >
        <CirclesWithBar
          height="100"
          width="100"
          color="#4fa94d"
          wrapperStyle={{
            margin: "auto",
          }}
          wrapperClass=""
          visible={globalLoaderCheck ? true : false}
          outerCircleColor="#3eff50"
          innerCircleColor="#3eff50"
          barColor="#3eff50"
          ariaLabel="circles-with-bar-loading"
        />
      </div>
      {!dealVideoDisplayed &&
      advertisePlayingIndex !== -1 &&
      advertisementDetail[advertisePlayingIndex]?.isDisplay ? (
        <>
          <div
            id="video-wrapper"
            style={{
              position: "fixed",
              zIndex: "999",
              width: 300,
              height: 250,
            }}
          >
            {advertisementDetail[advertisePlayingIndex]?.activeAdvert ? (
              <ReactPlayer
                url={advertisementDetail[advertisePlayingIndex]?.activeAdvert}
                width={300}
                height={250}
                playing={true}
                muted={true}
                controls={false}
                loop={false}
                onProgress={(progress) => {
                  if (
                    progress.playedSeconds &&
                    progress.playedSeconds > advertiseMaxTime
                  ) {
                    nextAdvertise();
                  }
                }}
                onEnded={() => {
                  nextAdvertise();
                }}
                youtubeConfig={{
                  playerVars: {
                    rel: 0,
                    showinfo: 0,
                    ecver: 2,
                    iv_load_policy: 3,
                    mute: 1,
                  },
                }}
              />
            ) : null}
          </div>
          <div
            id="video-wrapper-overlay-adv"
            style={{
              position: "fixed",
              zIndex: "1000",
              width: 300,
              height: 250,
            }}
          >
            <div className="video-player-skip-button">
              <Button
                type="button"
                className="font-semibold btn btn-save d-inline px-2 rounded mb-2 mr-2"
                onClick={() => {
                  nextAdvertise();
                }}
              >
                Skip AD <FaFastForward />
              </Button>
            </div>
          </div>
        </>
      ) : null}
      {/* <Router basename="/"> */}
      <ScrollToTop />
      <Header isComingSoon={isUnderMaintenance?.value} />
      <Switch>
        <Route
          path="/"
          exact={true}
          component={() => (
            <Home
              isComingSoon={isUnderMaintenance?.value}
              refresh={fetchSiteSetting}
              maintenanceTime={isUnderMaintenance?.time}
            />
          )}
        />
        <Route
          path="/video/:identifier"
          component={VideoWrapper}
          exact={true}
        />
        <Route path="/terms" component={TermsAndCondition} exact={true} />
        <Route
          path="/privacypolicy"
          component={PrivacyAndPolicy}
          exact={true}
        />
        <Route path="/aboutus" component={AboutUs} exact={true} />
        {!isUnderMaintenance?.value ? (
          <Fragment>
            {/* <Route path="/fancorner" component={FanCorner} exact={true} /> */}
            <Route
              path="/login/:user_uuid/:otp"
              exact={true}
              component={() => <Login refresh={fetchSiteSetting} />}
            />
            <Route
              path="/login"
              exact={true}
              component={() => <Login refresh={fetchSiteSetting} />}
            />
            <Route
              path="/register/:id"
              exact={true}
              component={() => <Signup />}
            />
            <Route path="/register" exact={true} component={() => <Signup />} />
            <Route
              path="/store/register"
              component={() => <Signup />}
              exact={true}
            />
            {/* <Route path="/store/dashboard" component={StoreDashboard} exact={true} /> */}
            {/* <Route path="/sponsor/register" component={SponsorRegistration} exact={true} /> */}
            <Route
              path="/sponsor/register"
              component={() => <Signup />}
              exact={true}
            />
            {/* Need to work on css in below route
                                -- pages/myProfile
                                -- pages/team
                                -- page/players.tsx
                            */}
            <Route path="/teams" exact={true} component={Teams} />
            <Route
              path="/team/:team_identifier"
              exact={true}
              component={Team}
            />
            <Route
              path="/players/:team_identifier"
              exact={true}
              component={players}
            />
            <Route
              path="/players"
              exact={true}
              component={DiffTeamPlayersList}
            />
            <Route
              path="/player/:player_identifier"
              exact={true}
              component={Player}
            />
            {/* <Route path="/myProfile" exact={true} component={MyProfile} /> */}
            <Route path="/user/profile" component={Profile} exact={true} />
            <Route path="/scan" exact={true} component={ScanIndex} />
            <Route path="/gallery" exact={true} component={GalleryIndex} />
            {/* <Route path="/sponsor/dashboard" component={SponsorDashboard} exact={true} /> */}
            <Route
              path="/admin/dashboard"
              component={AdminDashboard}
              exact={true}
            />
          </Fragment>
        ) : null}
        {/* <Route path="/myProfile" exact={true} component={MyProfile} />
                    enable alphaCode in signup Header */}
        <Route path="/*" />
      </Switch>
      <Footer />
      {/* </Router> */}
    </GoogleOauthContext.Provider>
  );
};
export default App;
